import { computed } from "vue";
import { useStore } from "vuex";
import { TeachingMode } from "@/models";
import { MODULES, vuexName } from "@/store/utils";

export const useTeachingMode = () => {
  const { getters } = useStore();
  return {
    isLpSidebarShrink: computed<boolean>(() => getters[vuexName(MODULES.TEACHER_ROOM.GETTERS.GET_TEACHING_MODE)] === TeachingMode.CloseLessonPlan),
  };
};
